import { CollectionPath } from "../../api/firebase/Types/CollectionPath";
import { IDocument } from "../interfaces/IDocument";

export abstract class Document implements IDocument {
  id?: string;
  abstract getCollectionPath(): CollectionPath;
}
